import { Badge } from 'react-bootstrap';
import { formatMoney } from '../../utils/format';

/**
 * Green when the patient owes nothing, red with the outstanding amount when
 * they do. Used in the patient list so unpaid dues are visible at a glance.
 */
export default function PaymentBadge({ payment, size }) {
  const billed = payment?.billed || 0;
  const due = payment?.due || 0;

  if (!payment || payment.visits === 0 || billed === 0) {
    return <span className="text-muted small">-</span>;
  }

  if (due > 0) {
    return (
      <Badge bg="danger" className={size === 'lg' ? 'fs-6' : ''}>
        <i className="bi bi-exclamation-circle me-1" />
        Due {formatMoney(due)}
      </Badge>
    );
  }

  return (
    <Badge bg="success" className={size === 'lg' ? 'fs-6' : ''}>
      <i className="bi bi-check-circle me-1" />
      Completed
    </Badge>
  );
}
